import styled, { css } from 'styled-components';
import { OVERLAY_WIDTH } from '@/app/components/search/components/Card/constants.ts';
import { imageWidthStyle } from '../../utils/styled';

export const Dot = styled.button<{ isSelected: boolean }>`
  width: 4px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.5);
  ${(props) => props.theme.mixins.margin({ right: 1 })};
  margin-right: 6px;
  border-radius: 2.5px;
  transition: all 0.2s;
  border: none;
  padding: 0;
  cursor: pointer;
  ${({ isSelected }) =>
    isSelected &&
    css`
      width: 6px;
      height: 6px;
      border-radius: 3.5px;
      background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
    `}

  &:focus-visible {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
    transform: scale(1.5);
  }
`;

const overlaySize = css`
  width: ${OVERLAY_WIDTH};
  min-width: ${OVERLAY_WIDTH};
  bottom: unset;
  top: 158px;
`;

const defaultSize = css`
  ${imageWidthStyle};
`;

export const DotsStyled = styled.div<{ isOverlay?: boolean; fullWidthOnMobile?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-height: 7px;
  height: 7px;
  position: absolute;
  left: 0;
  z-index: 2;
  bottom: 10px;
  opacity: 0;

  &:hover,
  &:focus-within {
    opacity: 1;
  }

  @media (max-width: 767px) {
    ${({ fullWidthOnMobile }) =>
      fullWidthOnMobile
        ? css`
            position: absolute;
            left: 50%;
            top: 126px;
            transform: translateX(-50%);
            opacity: 1;
          `
        : css`
            display: none;
          `};
  }

  ${({ isOverlay }) => (isOverlay ? overlaySize : defaultSize)}
`;
